import './FleetDealerSupport.scss';
import Card from './Card/FleetCard';

export default function FleetDealerSupport({ fields }) {
  return (
    <div className={'container fleet-dealer-support'}>
      <div className={'wrapper'} data-aos="fade-up">
        {fields?.cardList?.map((card, index) => {
          return <Card key={index} card={card?.fields} />;
        })}
      </div>
    </div>
  );
}
